(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_427f9ce"] && !Shopify.designMode) return;
  try {
    /* Non-critical product-detail carousels: one deferred bootstrap, near-viewport activation. */
(() => {
  if (window.__aiProductDetailCarouselsV2) return;
  window.__aiProductDetailCarouselsV2 = true;

  const selector = '[data-lookbook-carousel], [data-story-carousel]';
  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const cleanup = new WeakMap();
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          init(entry.target);
        }
      }, { rootMargin: '240px 0px' })
    : null;

  function init(root) {
    if (root.dataset.detailCarouselReady === 'true') return;
    root.dataset.detailCarouselReady = 'true';
    const kind = root.hasAttribute('data-lookbook-carousel') ? 'lookbook' : 'story';
    const viewport = root.querySelector(`[data-${kind}-viewport]`);
    if (!viewport) return;
    const slides = [...root.querySelectorAll(`[data-${kind}-slide]`)];
    if (!slides.length) return;
    const dots = [...root.querySelectorAll(`[data-${kind}-dot]`)];
    const prev = root.querySelector(`[data-${kind}-prev]`);
    const next = root.querySelector(`[data-${kind}-next]`);
    let active = 0;
    let frame = 0;

    function setActive(index) {
      if (index < 0 || index >= slides.length) return;
      active = index;
      slides.forEach((slide, i) => slide.toggleAttribute(`data-${kind}-active`, i === index));
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }

    function goTo(index, behavior) {
      if (!mobile.matches || index < 0 || index >= slides.length) return;
      setActive(index);
      const slide = slides[index];
      const left = slide.offsetLeft - (viewport.clientWidth - slide.clientWidth) / 2;
      viewport.scrollTo({
        left,
        behavior: behavior || (reducedMotion.matches ? 'auto' : 'smooth')
      });
    }

    function syncActive() {
      frame = 0;
      if (!mobile.matches) return;
      const center = viewport.scrollLeft + viewport.clientWidth / 2;
      let nearest = 0;
      let minDistance = Infinity;
      slides.forEach((slide, i) => {
        const distance = Math.abs(slide.offsetLeft + slide.clientWidth / 2 - center);
        if (distance < minDistance) {
          nearest = i;
          minDistance = distance;
        }
      });
      if (nearest !== active) setActive(nearest);
    }

    viewport.addEventListener('scroll', () => {
      if (!mobile.matches || frame) return;
      frame = requestAnimationFrame(syncActive);
    }, { passive: true });
    viewport.addEventListener('keydown', event => {
      if (!mobile.matches) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => goTo(index));
    });
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
    if (prev) prev.addEventListener('click', () => goTo(active - 1));
    if (next) next.addEventListener('click', () => goTo(active + 1));

    function onModeChange() {
      if (!mobile.matches) viewport.scrollLeft = 0;
      else requestAnimationFrame(() => goTo(active, 'auto'));
    }
    mobile.addEventListener('change', onModeChange);
    cleanup.set(root, () => {
      mobile.removeEventListener('change', onModeChange);
      if (frame) cancelAnimationFrame(frame);
    });
    setActive(0);
  }

  function scan() {
    document.querySelectorAll(selector).forEach(root => {
      if (root.dataset.detailCarouselReady === 'true' || observed.has(root)) return;
      observed.add(root);
      if (observer) observer.observe(root);
      else init(root);
    });
  }

  scan();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  }
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest(selector) || event.target.querySelector(selector);
    if (!root) return;
    if (observer) observer.unobserve(root);
    init(root);
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(root => {
      if (observer) observer.unobserve(root);
      const fn = cleanup.get(root);
      if (fn) fn();
      cleanup.delete(root);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-lookbook-carousel"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__aiProductDetailCarouselsV2) return;
  window.__aiProductDetailCarouselsV2 = true;
  const selector = '[data-lookbook-carousel], [data-story-carousel]';
  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const observed = new WeakSet();
  const cleanup = new WeakMap();
  const observer = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          observer.unobserve(entry.target);
          init(entry.target);
        }
      }, { rootMargin: '240px 0px' })
    : null;
  function init(root) {
    if (root.dataset.detailCarouselReady === 'true') return;
    root.dataset.detailCarouselReady = 'true';
    const kind = root.hasAttribute('data-lookbook-carousel') ? 'lookbook' : 'story';
    const viewport = root.querySelector(`[data-${kind}-viewport]`);
    if (!viewport) return;
    const slides = [...root.querySelectorAll(`[data-${kind}-slide]`)];
    if (!slides.length) return;
    const dots = [...root.querySelectorAll(`[data-${kind}-dot]`)];
    const prev = root.querySelector(`[data-${kind}-prev]`);
    const next = root.querySelector(`[data-${kind}-next]`);
    let active = 0;
    let frame = 0;
    function setActive(index) {
      if (index < 0 || index >= slides.length) return;
      active = index;
      slides.forEach((slide, i) => slide.toggleAttribute(`data-${kind}-active`, i === index));
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index === slides.length - 1;
    }
    function goTo(index, behavior) {
      if (!mobile.matches || index < 0 || index >= slides.length) return;
      setActive(index);
      const slide = slides[index];
      const left = slide.offsetLeft - (viewport.clientWidth - slide.clientWidth) / 2;
      viewport.scrollTo({
        left,
        behavior: behavior || (reducedMotion.matches ? 'auto' : 'smooth')
      });
    }
    function syncActive() {
      frame = 0;
      if (!mobile.matches) return;
      const center = viewport.scrollLeft + viewport.clientWidth / 2;
      let nearest = 0;
      let minDistance = Infinity;
      slides.forEach((slide, i) => {
        const distance = Math.abs(slide.offsetLeft + slide.clientWidth / 2 - center);
        if (distance < minDistance) {
          nearest = i;
          minDistance = distance;
        }
      });
      if (nearest !== active) setActive(nearest);
    }
    viewport.addEventListener('scroll', () => {
      if (!mobile.matches || frame) return;
      frame = requestAnimationFrame(syncActive);
    }, { passive: true });
    viewport.addEventListener('keydown', event => {
      if (!mobile.matches) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });
    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => goTo(index));
    });
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
    if (prev) prev.addEventListener('click', () => goTo(active - 1));
    if (next) next.addEventListener('click', () => goTo(active + 1));
    function onModeChange() {
      if (!mobile.matches) viewport.scrollLeft = 0;
      else requestAnimationFrame(() => goTo(active, 'auto'));
    }
    mobile.addEventListener('change', onModeChange);
    cleanup.set(root, () => {
      mobile.removeEventListener('change', onModeChange);
      if (frame) cancelAnimationFrame(frame);
    });
    setActive(0);
  }
  function scan() {
    document.querySelectorAll(selector).forEach(root => {
      if (root.dataset.detailCarouselReady === 'true' || observed.has(root)) return;
      observed.add(root);
      if (observer) observer.observe(root);
      else init(root);
    });
  }
  scan();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan, { once: true });
  }
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest(selector) || event.target.querySelector(selector);
    if (!root) return;
    if (observer) observer.unobserve(root);
    init(root);
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selector).forEach(root => {
      if (observer) observer.unobserve(root);
      const fn = cleanup.get(root);
      if (fn) fn();
      cleanup.delete(root);
    });
  });
})();

(() => {
  if (window.__khLookbookPortraitV1) return;
  window.__khLookbookPortraitV1 = true;

  const selector = '[data-lookbook-portrait]';
  const mobile = window.matchMedia('(max-width: 749px)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const ready = new WeakMap();
  const queued = new WeakSet();
  const nearViewport = 'IntersectionObserver' in window
    ? new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          nearViewport.unobserve(entry.target);
          initialize(entry.target);
        });
      }, { rootMargin: '240px 0px' })
    : null;

  function initialize(root) {
    if (ready.has(root)) return;
    const viewport = root.querySelector('[data-lookbook-viewport]');
    const track = root.querySelector('.ai-lookbook-track');
    const slides = Array.from(root.querySelectorAll('[data-lookbook-slide]'));
    if (!viewport || !track || !slides.length) return;

    const caption = root.querySelector('[data-lookbook-mobile-caption]');
    const heading = caption?.querySelector('.ai-lookbook-heading');
    const text = caption?.querySelector('.ai-lookbook-text');
    const dots = Array.from(root.querySelectorAll('[data-lookbook-dot]'));
    const previous = root.querySelector('[data-lookbook-prev]');
    const next = root.querySelector('[data-lookbook-next]');
    let active = 0;
    let frame = 0;
    let settleTimer = 0;
    let items = slides;
    slides.forEach((slide, index) => slide.dataset.lookbookItemIndex = String(index));

    function setActive(index) {
      active = index;
      items.forEach(item => {
        item.toggleAttribute('data-lookbook-active', Number(item.dataset.lookbookItemIndex) === index);
      });
      dots.forEach((dot, i) => {
        if (i === index) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      const sourceHeading = slides[index].querySelector('.ai-lookbook-heading');
      const sourceText = slides[index].querySelector('.ai-lookbook-text');
      if (caption) {
        caption.hidden = !sourceHeading && !sourceText;
        if (heading) {
          heading.hidden = !sourceHeading;
          heading.textContent = sourceHeading?.textContent || '';
        }
        if (text) {
          text.hidden = !sourceText;
          text.innerHTML = sourceText?.innerHTML || '';
        }
      }
      if (previous) previous.disabled = slides.length < 2;
      if (next) next.disabled = slides.length < 2;
    }

    function scrollToItem(item, behavior = 'auto') {
      if (!item || !mobile.matches) return;
      const left = item.offsetLeft - (viewport.clientWidth - item.clientWidth) / 2;
      viewport.scrollTo({ left, behavior });
    }

    function nearestItem() {
      const center = viewport.scrollLeft + viewport.clientWidth / 2;
      let nearest = items[0];
      let distance = Infinity;
      items.forEach(item => {
        const candidate = Math.abs(item.offsetLeft + item.clientWidth / 2 - center);
        if (candidate < distance) {
          nearest = item;
          distance = candidate;
        }
      });
      return nearest;
    }

    function normalizeLoop() {
      if (!mobile.matches || !root.isConnected) return;
      const item = nearestItem();
      if (item?.hasAttribute('data-lookbook-clone')) {
        const index = Number(item.dataset.lookbookItemIndex);
        setActive(index);
        scrollToItem(slides[index]);
      }
    }

    function syncFromScroll() {
      frame = 0;
      if (!mobile.matches) return;
      const item = nearestItem();
      const index = Number(item.dataset.lookbookItemIndex);
      if (index !== active) setActive(index);
    }

    function onScroll() {
      if (!mobile.matches) return;
      if (!frame) frame = requestAnimationFrame(syncFromScroll);
      clearTimeout(settleTimer);
      settleTimer = setTimeout(normalizeLoop, 180);
    }

    function goTo(index) {
      if (!mobile.matches) return;
      const wrapped = (index + slides.length) % slides.length;
      let target = slides[wrapped];
      if (slides.length > 1 && index < 0) target = items[0];
      if (slides.length > 1 && index >= slides.length) target = items[items.length - 1];
      setActive(wrapped);
      scrollToItem(target, reducedMotion.matches ? 'auto' : 'smooth');
    }

    function buildMode() {
      clearTimeout(settleTimer);
      track.querySelectorAll('[data-lookbook-clone]').forEach(clone => clone.remove());
      if (mobile.matches && slides.length > 1) {
        const before = slides[slides.length - 1].cloneNode(true);
        const after = slides[0].cloneNode(true);
        [before, after].forEach(clone => {
          clone.removeAttribute('data-lookbook-slide');
          clone.setAttribute('data-lookbook-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.querySelectorAll('img').forEach(img => img.alt = '');
        });
        track.prepend(before);
        track.append(after);
      }
      items = Array.from(track.querySelectorAll('[data-lookbook-item-index]'));
      setActive(active);
      if (mobile.matches) {
        requestAnimationFrame(() => {
          if (root.isConnected) scrollToItem(slides[active]);
        });
      } else {
        viewport.scrollLeft = 0;
      }
    }

    function onTrackClick(event) {
      if (!mobile.matches) return;
      const item = event.target.closest('[data-lookbook-item-index]');
      if (!item || !track.contains(item)) return;
      setActive(Number(item.dataset.lookbookItemIndex));
      scrollToItem(item, reducedMotion.matches ? 'auto' : 'smooth');
    }

    function onKeydown(event) {
      if (!mobile.matches) return;
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault();
        goTo(active + (event.key === 'ArrowRight' ? 1 : -1));
      }
    }

    viewport.addEventListener('scroll', onScroll, { passive: true });
    viewport.addEventListener('scrollend', normalizeLoop);
    viewport.addEventListener('keydown', onKeydown);
    track.addEventListener('click', onTrackClick);
    dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
    if (previous) previous.addEventListener('click', () => goTo(active - 1));
    if (next) next.addEventListener('click', () => goTo(active + 1));
    mobile.addEventListener('change', buildMode);

    const resize = 'ResizeObserver' in window ? new ResizeObserver(() => {
      if (mobile.matches && root.isConnected) scrollToItem(slides[active]);
    }) : null;
    resize?.observe(viewport);

    ready.set(root, () => {
      mobile.removeEventListener('change', buildMode);
      resize?.disconnect();
      viewport.removeEventListener('scroll', onScroll);
      viewport.removeEventListener('scrollend', normalizeLoop);
      viewport.removeEventListener('keydown', onKeydown);
      track.removeEventListener('click', onTrackClick);
      if (frame) cancelAnimationFrame(frame);
      clearTimeout(settleTimer);
      ready.delete(root);
      queued.delete(root);
    });
    buildMode();
  }

  function scan(scope = document) {
    const roots = [];
    if (scope instanceof Element && scope.matches(selector)) roots.push(scope);
    roots.push(...scope.querySelectorAll(selector));
    roots.forEach(root => {
      if (ready.has(root) || queued.has(root)) return;
      queued.add(root);
      if (nearViewport) nearViewport.observe(root);
      else initialize(root);
    });
  }

  scan();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:block:select', event => {
    const root = event.target.closest(selector) || event.target.querySelector(selector);
    if (!root) return;
    nearViewport?.unobserve(root);
    initialize(root);
  });
  document.addEventListener('shopify:section:unload', event => {
    const roots = Array.from(event.target.querySelectorAll(selector));
    if (event.target.matches(selector)) roots.push(event.target);
    roots.forEach(root => {
      nearViewport?.unobserve(root);
      ready.get(root)?.();
      queued.delete(root);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
